import React from "react";
import ReactModal from "react-modal";
import { EditableProject } from "../reducers/environments";

const modalStyles = {
  content: {
    zIndex: 10050,
    minHeight: `100px`,
    width: 600,
    top: "auto",
    bottom: "auto",
    right: "auto",
    left: "auto",
    position: "static" as "static",
    display: "flex",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, .8)",
    zIndex: 10000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
export type ProjectDeletionModalState = {
  project: EditableProject;
  onClose?: () => void;
  onDelete: (project: EditableProject) => void;
};

export const DeleteProjectModal: React.FC<ProjectDeletionModalState> = ({
  project,
  onClose,
  onDelete,
}) => {
  const onConfirm = React.useCallback(() => {
    onDelete(project);
  }, [onDelete, project]);

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel="Delete Project?"
    >
      <div className="flex flex-col justify-between w-full">
        <div className="pb-4 mb-4 border-b">
          <h2 className="text-xl text-gray-900">{"Delete Project?"}</h2>
          <h4 className="text-md uppercase text-gray-500 font-bold">
            Project: {project.name}
          </h4>
        </div>

        <p className="text-xs text-gray-700">
          This action will delete this project as well as its environments
        </p>

        <div className="mt-8">
          <div className="flex space-between">
            <button
              className="w-full rounded btn py-2 bg-gray-100 text-gray-900 hover:bg-gray-200 text-center "
              onClick={onClose}
            >
              Cancel
            </button>
            <div className="w-4 flex-shrink-0 flex-grow-0" />
            <button
              className="rounded w-full btn py-2 text-center bg-red-500 text-white hover:bg-red-300"
              onClick={onConfirm}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
